import type { FaireProductEntity } from "../../entity_types/product";

export const p_4n93vwxpjm: FaireProductEntity = {
  token: "p_4n93vwxpjm",
  type: "product",
  name: "Reiki Symbol Amethyst Power Balance Enhancement Healing",
  brandToken: "b_pxpb5s3cxg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8d6a39b968102e328b4d8ec72ed5ea0defa031575fd9cc2fb1bb894a0d6f1198.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d5a39324e0df0fbe0f1a9a9c16c035e9fbc8fa3fb4b993e74ff6d1b2e588539d.jpeg",
    "https://cdn.faire.com/fastly/2562b904e9463c14319d0a54ab276cebf56621f46fd03e9495b73f07e380a737.jpeg",
    "https://cdn.faire.com/fastly/27903e1a8a816b0087b0254f10cda997dc2f99aed64bae70765b2a227864434d.jpeg",
    "https://cdn.faire.com/fastly/d090bcf60cf615ec2967859e1a254dca0d4ac4fb87c693d6891343aa7a37decf.jpeg",
    "https://cdn.faire.com/fastly/fecd482f491a02864094f1711aac33759449e55faf9a1b299899c564e5ff22c3.jpeg",
    "https://cdn.faire.com/fastly/c00060c98f4bdfbc9ac546326da0096606451f9fcf7762f51c7bf495d9e38973.jpeg",
    "https://cdn.faire.com/fastly/a5ebfc3a641fea54a290971b2c29a1e1dd8f2b13e10d6561668b0ef7c56858b1.jpeg",
    "https://cdn.faire.com/fastly/5e00268c4c3d773dad15c4d2b9fb878cd43221cf0528320e86d9aae421176fd4.jpeg",
    "https://cdn.faire.com/fastly/f3beed90440bd42709c0cdc961021c48d20ac35ab8339b7e69fc12e11e84ef4a.jpeg",
    "https://cdn.faire.com/fastly/f35ade0bb55832f3e761bcdb7e1e189ac16fdfcba10b8378ba0334723edc4b12.jpeg",
    "https://cdn.faire.com/fastly/58b12c4d8e5538a324df25a7b6803af7fbdd4ea6d068711bee26c43b49ada279.jpeg",
    "https://cdn.faire.com/fastly/1023ad13fbc39ff21f6753431e5de361bb34c45d650da1138406e3356298a66b.jpeg",
    "https://cdn.faire.com/fastly/3fbe81e3269204696cfe60c5f7ca68375e909431fb32bd9359d33c6a8a4275f0.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "'-ID: GEM-YWKS-RU2505\n-Stones: Amethyst Agate Stone\n-Weight(s): 30g\n-Size: 25*25mm\n-Quality: Excellent\n-Lead Free, Nickel Free",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:29:32.113Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
